import React from 'react';

const PlayButton = () => (
  <svg viewBox="0 0 18 18" focusable="false">
    <path d="M3.5 17.8l11.2-7.9a1.2 1.2 0 0 0 0-1.9L3.5.2a1 1 0 0 0-1.5.9v15.8a1 1 0 0 0 1.5.9z" />
  </svg>
);

export default PlayButton;
